import { useEffect, useState } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Helper to get cookie preferences
const getCookiePreferences = () => {
  try {
    const prefs = localStorage.getItem('cookiePreferences');
    return prefs ? JSON.parse(prefs) : null;
  } catch {
    return null;
  }
};

// Helper to check if analytics is allowed
const isAnalyticsAllowed = () => {
  const prefs = getCookiePreferences();
  return prefs?.analytics === true;
};

export const GoogleAnalytics = () => {
  const [gaId, setGaId] = useState('');
  const [loaded, setLoaded] = useState(false);

  // Fetch GA ID from backend
  useEffect(() => {
    const fetchGaId = async () => {
      try {
        const res = await fetch(`${API_URL}/api/analytics-config`);
        if (res.ok) {
          const data = await res.json();
          if (data.google_analytics_id) {
            setGaId(data.google_analytics_id);
          }
        }
      } catch (err) {
        console.error('Failed to fetch analytics config:', err);
      }
    };
    fetchGaId();
  }, []);

  // Load GA script only when analytics is allowed and we have a GA ID
  useEffect(() => {
    if (!gaId || loaded) return;

    // Check if analytics cookies are allowed
    if (!isAnalyticsAllowed()) {
      console.log('Analytics cookies not accepted - GA not loaded');
      return;
    }

    // Load Google Analytics
    const loadGA = () => {
      // Add gtag script
      const script = document.createElement('script');
      script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
      script.async = true;
      document.head.appendChild(script);

      // Initialize gtag
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        window.dataLayer.push(arguments);
      }
      window.gtag = gtag;
      gtag('js', new Date());
      gtag('config', gaId, {
        anonymize_ip: true,
        cookie_flags: 'SameSite=None;Secure'
      });

      setLoaded(true);
      console.log('Google Analytics loaded:', gaId);
    };

    loadGA();
  }, [gaId, loaded]);

  // Listen for cookie preference changes
  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === 'cookiePreferences') {
        // Reload page to apply new preferences
        // This is the simplest way to handle consent changes
        window.location.reload();
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  return null; // This component doesn't render anything
};

export default GoogleAnalytics;
